import ReactOnRails from 'react-on-rails';
import {
  AttentionGrabber,
  ErrorPage,
  HeaderMenu,
  InteractiveNotifications,
  RailsReactHookWrapper,
  ProgressSpinner,
  SystemBanner,
  SystemNotifications,
  StorageUtil,
} from 'reactifi';
import ImportBatchesApp from './ImportBatches';
import RegistrationApp from './Registration';
import AutoLogout from '../lib/components/AutoLogout';

StorageUtil.clearSessionActiveProps();

ReactOnRails.register({
  AttentionGrabber,
  AutoLogout,
  ErrorPage,
  HeaderMenu,
  ImportBatchesApp,
  InteractiveNotifications,
  ProgressSpinner,
  RailsReactHookWrapper,
  RegistrationApp,
  SystemNotifications,
  SystemBanner,
});
